export { default } from './CoreRepHeader';
